'use strict';

var _extends = require('../../../../../../@babel/runtime/helpers/esm/extends.cjs');
var React = require('react');
var ReactDOM = require('react-dom');
var index = require('../../../../../react-primitive/dist/index.cjs');

const $f1701beae083dbae$export$602eac185826482c = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    var _globalThis$document;
    const { container: container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body , ...portalProps } = props;
    return container ? /*#__PURE__*/ ReactDOM.createPortal(/*#__PURE__*/ React.createElement(index.Primitive.div, _extends({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});

exports.Portal = $f1701beae083dbae$export$602eac185826482c;
//# sourceMappingURL=index.cjs.map
